module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breadcrumbs-container row"
  }, [_c('div', {
    staticClass: "power-btn",
    class: {
      active: _vm.position == -1
    },
    on: {
      "click": _vm.home
    }
  }, [_c('span', {
    staticClass: "mid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "icon-holder",
    domProps: {
      "innerHTML": _vm._s(_vm.SVGGraphics.default.urlIconTwo)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "front"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "breadcrumbs-list row"
  }, [_c('transition-group', {
    attrs: {
      "mode": "out-in",
      "name": "breadcrumb-list"
    }
  }, _vm._l((_vm.breadcrumbList), function(name, index) {
    return _c('BreadcrumbElement', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.value),
        expression: "value"
      }],
      key: index,
      attrs: {
        "index": index,
        "position": _vm.position,
        "header": name,
        "width": _vm.elementWidth
      },
      on: {
        "breadcrumb-click": function($event) {
          _vm.breadcrumbClick(index)
        }
      }
    })
  })), _vm._v(" "), _c('li', {
    ref: "slider",
    staticClass: "slide-state breadcrumb"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "mid"
  }), _vm._v(" "), _c('span', {
    staticClass: "front"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "breadcrumbs-container__underlay"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', [_vm._v("RETURN TO START")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "back"
  }, [_c('span', {
    staticClass: "top-arrow"
  }), _vm._v(" "), _c('span', {
    staticClass: "bottom-arrow"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c709992","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radius/Breadcrumb/Breadcrumbs.vue
// module id = ssXg
// module chunks = 1